import styled from 'styled-components';
import { TOP_HEADER_HEIGHT } from 'modules/constants';
import { pxToRem, unit } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
export const NavigationBar = styled.div `
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: ${unit('lg')} 0;
  background-color: ${themeGet('colors.gray.0')};
  width: 100%;
  height: ${pxToRem(TOP_HEADER_HEIGHT)};
  position: sticky;
  top: 0;
  z-index: 1;
`;
